var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',[_c('center',[_c('div',{class:_vm.finalized ? 'circle-loader ' + _vm.classResult  : 'circle-loader'},[_c('div',{staticClass:"status draw"})]),_c('transition',{attrs:{"name":"fade"}},[_c('h4',[_vm._v(_vm._s(_vm.saveDivMessage))])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }